export const work_desc=[
    {
        title:"Basic Banking System",
        image:"images/bank.jpg",
        tech:['HTML',"CSS","PHP","SQL","PHPMYADMIN"],
        desc:"Basic Banking System is the Webapp made using php as backend server and it shows the basic transcation between the users and transaction history",
        github:"https://github.com/Kesav-21/Basic-Banking-System",
        live:"https://spark-kesav.000webhostapp.com/"
    },
    {
        title:"Donate Payment Gateway",
        image:"images/donate.png",
        tech:['HTML','CSS','ReactJS','Javascript','Payment Gateway'],
        desc:"This is the charity like website which allows to contribute to charity through online using online payment modes",
        github:"https://github.com/Kesav-21/DonatePageWithPaymentIntegration",
        live:"https://dopayint.netlify.app",
    },
    {
        title:"Work Tables",
        image:"images/work.jpg",
        tech:['HTML','CSS','Javascript','ReactJS'],
        desc:"Work Tables is the design of webpage it shows the details of the employees working in which table of the company and on which project he/she is invloved,using this we can filter and view the particular tables and hovering on the chair will show th information of the employee and project details",
        github:"https://github.com/Kesav-21/worktables",
        live:"http://kesav-21.github.io/worktables",
    },
    {
        title:"Quotes Generator",
        image:"images/quote.jpg",
        tech:['HTML','CSS','Javascript'],
        desc:"Quotes Generator website is build using the predefined set of quotes which are displayed randomly on clicking the button",
        github:"https://github.com/Kesav-21/RandomQuote",
        live:"https://kesav-21.github.io/RandomQuote",
    },
    {
        title:"Pomorodo Clock",
        image:"images/clock.jpg",
        tech:['HTML','CSS','Javascript'],
        desc:"Pomorodo Clock is the stopclock which has timer running on to keep track of any thing within that time period",
        github:"https://github.com/Kesav-21/Build-25-5-clock",
        live:"https://kesav-21.github.io/Build-25-5-clock/",
    },
    {
        title:"Calculator",
        image:"images/calculator.jpg",
        tech:['HTML','CSS','Javascript'],
        desc:"It is a Simple JS calculator made to perform basic operations like Addition, Subtraction, Division, Multiplication.",
        github:"https://github.com/Kesav-21/SimpleJSCalculator",
        live:"https://kesav-21.github.io/SimpleJSCalculator/",
    },
    {
        title:"Survey Form",
        image:"images/survey.jpg",
        tech:['HTML','CSS','Javascript'],
        desc:"It is simple form built by using different form fields available in the HTML",
        github:"https://github.com/Kesav-21/SurveyForm",
        live:"https://kesav-21.github.io/SurveyForm",
    },
    {
        title:"MarkDown Previewer",
        image:"images/markdown.png",
        tech:['HTML','CSS','Javascript'],
        desc:"Markdown is a lightweight markup language with plain text formatting syntax. It is a simple way to add formatting like headers, bold, bulleted lists, and so on to a plain text. Markdown uses a simple formatting syntax to accomplish the same thing that HTML does, but it is simpler than HTML.",
        github:"https://github.com/Kesav-21/MarkDownPreviewer",
        live:"https://kesav-21.github.io/MarkDownPreviewer/",
    },
    {
        title:"Sound Machine",
        image:"images/sound.png",
        tech:['HTML','CSS','Javascript'],
        desc:"Sound Machine is simple js website which behaves differently on different key presses in the keyboard or either mouse click it plays different sound on different key press",
        github:"https://github.com/Kesav-21/SoundMachine",
        live:"https://kesav-21.github.io/SoundMachine/",
    },
    {
        title:"Product Landing page",
        image:"images/product.jpg",
        tech:['HTML','CSS','Javascript'],
        desc:"A product landing page is a post-click page created specifically to convince a visitor to convert on a product-related offer. Design-wise, it's similar a traditional landing page.",
        github:"https://github.com/Kesav-21/ProductLandingPage",
        live:"https://kesav-21.github.io/ProductLandingPage/",
    },
    {
        title:"Phone Directory",
        image:"images/phonebook.png",
        tech:['HTML','CSS','Javascript','ReactJS'],
        desc:"a Database that lists the names, addresses, and phone numbers of the people and businesses in a certain area.Using this webapp you can add and manage the phone numbers of the person",
        github:"https://github.com/Kesav-21/Phone-Directory",
        live:"https://phonedirectoryk7.netlify.app/",
    },
    {
        title:"Task Adder",
        image:"images/task.jpg",
        tech:['HTML','CSS','JavaScript','ReactJS'],
        desc:"A task tracker is an intelligent version of a to-do list that can help manage tasks and assignments. Team members can use task trackers individually or together as a team. These allow team members to list their essential projects, prioritize them, and mark them as done when the tasks are complete.",
        github:"https://github.com/Kesav-21/Task-Tracker",
        live:"https://tasktrackerkesav.netlify.app/",
    }
    ,
    {
        title:"Housing Finder using Firebase",
        image:"images/housing.png",
        tech:['HTML','CSS','JS','ReactJS','Firebase','Tailwind'],
        desc:"It is the website that helps to find the houses that are available for sale/rent using the reactjs and firebase is used to provide the adding the listing,delete the listing,view the listing and user authentication,etc.",
        github:"https://github.com/Kesav-21/HousingFinder",
        live:"https://housingfinderclok7.netlify.app",
    },
    {
        title:"ToDoList Using Flask",
        image:"images/todolist.png",
        tech:['HTML','CSS','Flask','SQLAlchemy'],
        desc:"It is the website used to keep track of the to do tasks and store them in the database and can access from anywhere",
        github:"https://github.com/Kesav-21/todolist",
        live:"https://todolist-jyvz.onrender.com/"
    }

]